<template>
	<div>
		<pui-datatable
			:modelName="modelName"
			:actions="actions"
			:modelColumnDefs="modelColumnDefs"
			:externalFilter="externalFilter"
			:showCreateBtn="false"
			:showDeleteBtn="false"
			readOnly
		></pui-datatable>
		<anchorageoperations-modals :modelName="model"></anchorageoperations-modals>
	</div>
</template>

<script>
import PuiGridDetailMixin from 'pui9-mixins/PuiGridDetailMixin';
import anchorageoperationsActions from './AnchorageoperationsActions';
import anchorageoperationsModals from './AnchorageoperationsModals.vue';

export default {
	name: 'anchorageoperations-grid',
	mixins: [PuiGridDetailMixin],
	components: {
		'anchorageoperations-modals': anchorageoperationsModals
	},
	data() {
		return {
			model: 'anchorageoperations',
			modelName: 'anchorageoperations',
			actions: anchorageoperationsActions.gridactions,
			modelColumnDefs: {
				statuscode: this.generateCellStyle(),
				arrivalhmstatus: this.generateCellStyle(),
				arrivalcuofstatus: this.generateCellStyle(),
				arrivalppstatus: this.generateCellStyle(),
				departurehmstatus: this.generateCellStyle(),
				departurecuofstatus: this.generateCellStyle(),
				departureppstatus: this.generateCellStyle()
			}
		};
	},
	methods: {
		generateCellStyle() {
			return {
				render: (data) => {
					let style = '';
					switch (data) {
						// ARRIVAL
						case 'ARRIVAL APPROVED':
						case 'ARRIVAL AUTHORIZED':
							style = 'background-color:#24a54e9e;';
							break;
						case 'ARRIVAL DENIED':
							style = 'background-color:#e8624d;';
							break;
						case 'ARRIVAL REQUESTED':
							style = 'background-color:#e9711aa1;';
							break;

						// DEPARTURE
						case 'DEPARTURE APPROVED':
						case 'DEPARTURE AUTHORIZED':
							style = 'background-color:#24a54e9e;';
							break;
						case 'DEPARTURE DENIED':
							style = 'background-color:#e8624d;';
							break;
						case 'DEPARTURE REQUESTED':
							style = 'background-color:#e9711aa1;';
							break;

						case 'APPROVED':
						case 'AUTHORIZED':
							style = 'background-color: #24a54e9e;';
							break;
						case 'DENIED':
							style = 'background-color: #e8624d;';
							break;
						case 'PENDING':
							style = 'background-color: #e9711aa1;';
							break;
						default:
							break;
					}
					return `<div style="${style} font-weight: bold; padding: 6px 10px; border-radius: 10px; text-align: center;">
					${data}
				</div>`;
				}
			};
		}
	}
};
</script>
